import { App as AntApp, ConfigProvider } from 'antd';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import AppInit from './components/AppInit';
import Dashboard from './components/Dashboard';
import DashboardLayout from './components/DashboardLayout';
import MeetingRequestForm from './components/MeetingRequestFormWrapper';
import Meetings from './components/Meetings';
import ForgotPasswordPage from './components/pages/ForgotPasswordPage';
import LoginPage from './components/pages/LoginPage';
import ResetPasswordPage from './components/pages/ResetPasswordPage';
import ProtectedRoute from './components/ProtectedRoute';
import UserManagement from './components/UserManagement';
import ZonesPage from './components/ZonesPage';
import DeleteManagement from './components/DeleteManagement';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#fc4c02',
          // fontFamily: 'Satoshi',
        },
      }}
    >
      <AntApp>
        {location.pathname !== '/login' &&
          location.pathname !== '/forgot-password' &&
          location.pathname !== '/reset-password' && 
          location.pathname !== '/form' &&
          <AppInit />}
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/form" element={<MeetingRequestForm />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<DashboardLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="/visits" element={<Meetings />} />
              <Route path="zones" element={<ZonesPage />} />
              <Route path="users" element={<UserManagement />}  />
              <Route path="delete-user" element={<DeleteManagement />}  />
            </Route>
          </Route>
        </Routes>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
